export default __webpack_public_path__ + "static/2-2842a6ddb33db8dab473f96650cf8724.png";